import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from 'vuex';
import Dashboard from '../views/DashboardView.vue'
import Profile from '../views/ProfileView.vue'
import Departments from '../views/DepartmentsView.vue'
import Roles from '../views/RolesView.vue'
import StaffMgt from '../views/StaffMgt.vue'
import ForbiddenView from '../views/ForbiddenView.vue'
import TaskOverview from '../views/TasksOverview.vue'
import ProjectsView from '../views/ProjectsView.vue'
import TasksView from '../views/TasksView.vue'
import MyTasksView from '../views/MyTaskView.vue'
import CustomerList from '../views/CustomerList.vue'
import CComplaints from '@/views/CComplaints.vue';
import NotFound from '@/views/NotFound.vue';
import InactiveOffice from '@/views/InactiveOffice.vue';
import BusinessSettings from '@/views/BusinessSettings.vue';
import SubPackage from '@/views/SubscriptionPackages.vue';
import SubHistory from '@/views/SubscriptionHistory.vue'
import TransactionsView from '@/views/TransactionsView.vue'
import AccountsView from '@/views/AccountsView.vue'
import TransactionsReport from '@/views/TransactionsReport.vue';
import PayTemplate from '@/views/PayTemplate.vue';
import SalaryMgt from '@/views/SalaryMgt.vue';
import PaySalary from '@/views/PaySalary.vue';
import CreateInvoice from '@/views/CreateInvoice.vue';
import ViewInvoice from '@/views/ViewInvoice.vue';
import AllInvoice from '@/views/AllInvoice.vue';
import InvoiceHistory from '@/views/InvoiceHistory.vue';
import EditInvoice from '@/views/EditInvoice.vue';
import SectionInvoice from '@/views/SectionInvoice.vue';
import MySchedule from '@/views/MySchedule.vue';
import CalendarView from '@/views/CalendarView.vue';
import VendorsList from '@/views/VendorsList.vue';

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/profile/:profileId/:page',
    name: 'profile',
    component: Profile
  },
  {
    path: '/departments',
    name: 'departments',
    component: Departments,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Department', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/roles',
    name: 'roles',
    component: Roles,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Roles', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/staff',
    name: 'staff',
    component: StaffMgt,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Team', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: ForbiddenView
  },
  {
    path: '/taskoverview',
    name: 'taskoverview',
    component: TaskOverview
  },
  {
    path: '/projectsview',
    name: 'projectsview',
    component: ProjectsView,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Project', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/tasks/:project',
    name: 'tasksview',
    component: TasksView,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Project', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/mytasks',
    name: 'mytasks',
    component: MyTasksView,
    meta: {
      requiresAuth: true,
      permission: { resource: 'My Task', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/customerlist',
    name: 'customerlist',
    component: CustomerList,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Customers List', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/customer_complaints/:customerId',
    name: 'ccomplaints',
    component: CComplaints,
    meta: {
      requiresAuth: true,
      permission: { resource: 'CRMs', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/inactive_office',
    name: 'inactive_office',
    component: InactiveOffice
  },
  {
    path: '/business_settings/:page',
    name: 'business_settings',
    component: BusinessSettings,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Settings', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/subpackage',
    name: 'subpackage',
    component: SubPackage,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Subscription Admin', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/subhistory/:customerId',
    name: 'subhistory',
    component: SubHistory,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Subscription', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: TransactionsView,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Transactions', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/transactionReport',
    name: 'transactionreport',
    component: TransactionsReport,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Transactions', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: AccountsView,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Accounts', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/paytemplate',
    name: 'paytemplate',
    component: PayTemplate,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Payroll', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/salarymgt',
    name: 'salarymgt',
    component: SalaryMgt,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Payroll', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/paysalary',
    name: 'paysalary',
    component: PaySalary,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Payroll', action: 'view' }, // Permission needed
    }
  },
  {
    path: '/createinvoice',
    name: 'createinvoice',
    component: CreateInvoice,
    meta: {
      requiresAuth: true,
      permission: { resource: 'Invoice', action: 'create' }, // Permission needed
    }
  },
    {
      path: '/allinvoice',
      name: 'allinvoice',
      component: AllInvoice,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Invoice', action: 'view' }, // Permission needed
      }
    },
    {
      path: '/viewinvoice/:id',
      name: 'viewinvoice',
      component: ViewInvoice,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Invoice', action: 'view' }, // Permission needed
      }
    },
    {
      path: '/invoice_history/:id',
      name: 'invoicehistory',
      component: InvoiceHistory,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Invoice', action: 'view' }, // Permission needed
      }
    },
    {
      path: '/editinvoice/:id',
      name: 'editinvoice',
      component: EditInvoice,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Invoice', action: 'edit' }, // Permission needed
      }
    },
    {
      path: '/invoices/:type',
      name: 'invoices',
      component: SectionInvoice,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Invoice', action: 'view' }, // Permission needed
      }
    },
    {
      path: '/myschedule',
      name: 'myschedule',
      component: MySchedule,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Schedule', action: 'view' }, // Permission needed
      }
    },
    {
      path: '/calendar/:id/:type',
      name: 'calendar',
      component: CalendarView
    },
    {
      path: '/vendorslist',
      name: 'vendorslist',
      component: VendorsList,
      meta: {
        requiresAuth: true,
        permission: { resource: 'Vendors List', action: 'view' }, // Permission needed
      }
    },
   // Catch-all 404 route (MUST be at the end)
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const store = useStore(); // Access Vuex store

  // Ensure permissions are loaded
  if (!store.state.Permission.permissions || store.state.Permission.permissions.length === 0) {
    try {
      await store.dispatch('Permission/fetchPermissions'); // Fetch and transform permissions
    } catch (error) {
      console.error('Failed to fetch permissions:', error);
    }
  }

  // Check permissions if required
  if (to.meta.permission) {
    const { resource, action } = to.meta.permission;
    const hasPermission = store.getters['Permission/hasPermission'](resource, action);

    if (!hasPermission) {
      return next('/unauthorized'); // Redirect to unauthorized page
    }
  }

  next(); // Allow navigation if all checks pass
});

export default router
